import React, { Suspense, lazy } from "react";

import NoAuth from "../no-auth";
import CallToAction from "./CallToAction";
import FAQ from "./FAQ";

// Helpers
const Main = lazy(() => import("./main"));
const PricingPreview = lazy(() => import("./PricingPreview").then(module => ({ default: module.PricingPreview })));
const Products = lazy(() => import("./Products"));
const NewProducts = lazy(() => import("./NewProducts"));

const HomeContent = () => (
  <>
    <Main />
    <NewProducts />
    <Products />
    <PricingPreview />
    <FAQ />
    <CallToAction />
  </>
);

const Home = () => {
  return (
    <Suspense fallback={null}>
      <NoAuth component={HomeContent} title={('')} />
    </Suspense>
  );
};

export default Home;
